import React from "react";
import PropTypes from "prop-types";
import { Alert, AlertTitle, Stack } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import Typography from "@components_v2/typography/typography";
import { useTranslation } from "react-i18next";
import { alpha } from "@mui/material";

// TODO: 에러 메시지 박스 UI 추상화 및 공통 컴포넌트로 분리

export function NoProjectErrorMessageBox({ t = (f) => f }) {
    return (
        <Alert
            severity="error"
            color="error"
            sx={{
                backgroundColor: alpha(theme.palette.error[50], 0.5),
                borderRadius: theme.spacing(0.5),
                "& .MuiAlert-icon": {
                    alignItems: "flex-start",
                },
                "& .MuiAlert-message": {
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: theme.spacing(1),
                },
            }}
        >
            <Typography variant={"body1_500"} color={theme.palette.greySecondary.main}>
                {t(`common::msg::There is no project available to access.`)}
            </Typography>
            <Typography variant={"body1_00"} color={theme.palette.greySecondary.main}>
                {t(`common::msg::Please contact your stage administrator to access the project.`)}
            </Typography>
        </Alert>
    );
}

export function CallMegazoneErrorMessageBox({ t = (f) => f }) {
    return (
        <div className={"gate-invalid"}>
            <div className={"card"}>
                <div className={"card-body"}>
                    <div className={"message"}>
                        <i className={"sprite sprite-error"}></i>
                        <p>
                            <strong className={"text-danger"}>
                                {t(`common::msg::${"You can't access the space."}`)}
                            </strong>
                            <span>
                                {t(
                                    `common::msg::${"The space is inaccessible because your account has expired or has been deleted."}`,
                                )}
                            </span>
                            <br />
                            <span>{t(`common::msg::${"Please contact your space manager."}`)}</span>
                        </p>
                    </div>
                    <hr />
                    <div className={"message"}>
                        <i className="sprite sprite-info-inverse"></i>
                        <p>
                            {t(
                                `common::msg::${"If you have issues with Space approval, please contact Megazone Cloud. "}`,
                            )}
                        </p>
                    </div>
                    <div className={"row"}>
                        <div className={"col"}>
                            <strong className={"title"}>
                                {t(`common::label::{{name}} inquiry`, { name: "Megazone" })}
                            </strong>
                            <p className={"dot"}>
                                <a href="https://mz-cloudplex.zendesk.com">https://mz-cloudplex.zendesk.com</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

NoProjectErrorMessageBox.propTypes = {
    t: PropTypes.func,
};

CallMegazoneErrorMessageBox.propTypes = {
    t: PropTypes.func,
};
